export default "__VITE_ASSET__BWYtrErf__"